import Checkbox from "components/input/check"
import styles from "./index.module.scss"
import Image from "next/image"
import { ChangeEvent, FC, useEffect, useState } from "react"
import formTypeConstant from "constants/form/questions/form-type"
import dynamic from "next/dynamic"
import IProjectTypes from "rules/interface/project/project-types.interface"




interface IProps {
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    value: IProjectTypes[]
    shake?: boolean
}


const FormTypesItem: FC<IProps> = ({ onChange, value, shake }) => {

    const [shakeIt, setShakeIt] = useState<boolean>(false)

    const renderCheckedItem = () => {
        const Checked = dynamic(() => import("components/checked"))

        return <Checked className={styles.checked__box} />
    }

    useEffect(() => {
        if (shake) {
            setShakeIt(true)

            setTimeout(() => {
                setShakeIt(false)
            }, 1000)
        } else {
            setShakeIt(false)
        }
    }, [shake])


    return (
        <div className={styles.form_types}>
            <ul className={styles.list__form_types + " flex jcc flex-wrap gap-10"}>
                {
                    formTypeConstant.map(item => {
                        const isActive = value.find(res => res.itemName === item.value)

                        return <li key={item.value} className={styles.item__list + ` ${shakeIt ? styles.shake__item : ""}`}>
                            <Checkbox
                                className={styles.box__item + ` flex align-i-center jcc gap-10 ${isActive ? styles.active_box__item : ""}`}
                                onChange={onChange}
                                value={item.value}
                                name={item.value}
                            >
                                {isActive && renderCheckedItem()}

                                <div className={styles.icon__box}>
                                    <Image
                                        src={item.icon}
                                        alt="تصویر سفارش"
                                        width={40}
                                        height={40}
                                        objectFit="fill"
                                    />
                                </div>
                                <span className={styles.caption__item}>
                                    {item.label}
                                </span>
                            </Checkbox>
                        </li>
                    })
                }

            </ul>

        </div>
    )
}

export default FormTypesItem